<template>
    <div id="feedback">
        <p class="black mb-0 custom-font-size">{{title}}</p>
        <p class="bold black mb-0">{{score.toFixed(2)}} de {{value}}</p>
        <vs-progress :percent="percent" :color="color"></vs-progress>
    </div>
</template>

<script>
export default {
    name: "statistics-feedback"
    , props: ['title', 'score', 'value', 'percent', 'color']
}
</script>

<style>
    .custom-font-size {
        font-size: 13px;
    }
</style>